import Page from '@/components/content/Page'
import { Translation } from '@/components/i18n/Translation'

import DeviceOrderFilter from './DeviceOrderFilter'
import DeviceOrderList from './DeviceOrderList'

const DeviceOrders = () => (
  <Page>
    <h1>
      <Translation id="Device Orders" />
    </h1>

    <DeviceOrderFilter />

    <DeviceOrderList />
  </Page>
)

export default DeviceOrders
